/**
 * Payment Cancel Page
 * Displayed when user cancels payment or payment fails
 */

import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft, Coins } from 'lucide-react';

export const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-background to-muted/20">
      <Card className="w-full max-w-md mx-4">
        <CardHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="rounded-full bg-orange-100 dark:bg-orange-900/20 p-3">
              <XCircle className="h-12 w-12 text-orange-600 dark:text-orange-400" />
            </div>
          </div>
          <CardTitle className="text-center">Payment Cancelled</CardTitle>
          <CardDescription className="text-center">
            Your payment was not completed
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="p-4 bg-muted/50 rounded-lg">
            <p className="text-sm text-muted-foreground text-center">
              No charges have been made to your account. You can try again whenever you're ready.
            </p>
          </div>

          <div className="space-y-3">
            <Button
              className="w-full"
              onClick={() => navigate('/preferences?tab=credits')}
            >
              <Coins className="h-4 w-4 mr-2" />
              Back to Credits & Billing
            </Button>
            <Button
              className="w-full"
              variant="outline"
              onClick={() => navigate('/')}
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Return to Home
            </Button>
          </div>

          <div className="pt-4 border-t">
            <h4 className="font-medium text-sm mb-2 text-center">Need Help?</h4>
            <p className="text-xs text-muted-foreground text-center">
              If you're experiencing issues with payment, please contact our support team.
              We're here to help!
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
